import { reset } from 'redux-form';
import {
    PROCESS_QUEUE,
} from '../constants/actionTypes';
import {
    salesPDFUpload,
    salesPut,
    salesGet,
    horsesList,
    horsesPut,
    enhancedHorsePhotosDeleteAll,
    horsePhotosDeleteSingle,
    postHorseUpdateOnSale,
    deleteHorseUpdateOnSale,
    updatesList,
    triggerUnderTackShowYoutube,
    checkForPP,
    checkForEhancedFiles,
} from './apiActions';
import { flashMessageSet } from './flashMessageActions';


export const uploadSalePDFProcess = (files) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            salesPDFUpload(files),
            salesGet(1),
            flashMessageSet('Sale PDF Uploaded', 'success'),
        ],
    };
};


export const saleSettingsUpdate = (form) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            salesPut(form),
            flashMessageSet('Settings Updated', 'success'),
        ],
    };
};

export const saveHorseProcess = (horse, form) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            horsesPut(horse, form),
            horsesList(),
            flashMessageSet('Horse Updated!', 'success'),
        ],
    };
};

export const saveUpdateProcess = (form) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            postHorseUpdateOnSale(form),
            reset(form),
            updatesList(),
            flashMessageSet('Update Added', 'success'),
        ],
    };
};

export const deleteUpdateProcess = (form) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            deleteHorseUpdateOnSale(form),
            reset(form),
            updatesList(),
            flashMessageSet('Update Removed', 'success'),
        ],
    };
};
export const enhancedHorsePhotosDeleteAllProcess = () => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            enhancedHorsePhotosDeleteAll(),
            horsesList(),
            flashMessageSet('All media of horses for this sale have been removed', 'success'),
        ],
    };
};
export const deleteSingleHorsePhoto = (id, photoType) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            horsePhotosDeleteSingle(id, photoType),
            horsesList(),
            flashMessageSet('Photo deleted!', 'success'),
        ],
    };
};

export const youtubeLinkUpdateProcess = (form) => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            triggerUnderTackShowYoutube(form),
            horsesList(),
            flashMessageSet('All horses associated with this sale have been updated', 'success'),
        ],
    };
};

export const checkForPPProcess = () => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            checkForPP(),
            horsesList(),
            flashMessageSet('Horses with PPs on the server for this sale were updated', 'success'),
        ],
    };
};

export const checkForEnhancedFilesProcess = () => {
    return {
        type: PROCESS_QUEUE,
        actions: [
            checkForEhancedFiles(),
            horsesList(),
            flashMessageSet('Horses with Enhanced Catalogue Files on the server for this sale were updated', 'success'),
        ],
    };
};
